
	import { Component, Vue } from 'vue-property-decorator';
	import { serverProps } from '@/Common/Environment/const';

	@Component({
		components: {}
	})
	export default class Notifications extends Vue {
		protected state: APS.IServerProps = serverProps;

		protected get notifications(): APS.INotifications {
			return this.state.notifications;
		}

		protected get isXSClientType(): boolean {
			return this.state.isXSClientType;
		}

		protected get error404(): boolean {
			return !!this.state.error404;
		}

		protected get localizedLabels(): APS.ILocalizedLabels {
			return this.notifications.localizedLabels;
		}

		protected get isUserAccountAdmin(): boolean {
			return this.notifications.isUserAccountAdmin;
		}

		protected onShowMoreClick(): void {
			window.aps.apsc.gotoURL('/i/pa/ccp-users/view-notifications');
		}
	}
